import React, { useRef } from 'react';
import usePlayer from 'src/components/PlayerMarkup/hooks/usePlayer';
import { IPlayerData, ISubtitles } from 'src/interfaces/PlayerData';
import useWatchTime from 'src/hooks/useWatchTime';
import { withUnleash } from 'next-unleash';
import { IWithUnleash } from 'src/interfaces/Unleash';
import classNames from 'classnames';
interface IPlayerMarkupProps extends IWithUnleash {
  playerData: IPlayerData;
  className?: string;
}

const renderTrackElements = (subtitles: ISubtitles[]) =>
  subtitles.map((subtitle) => (
    <track
      kind='subtitles'
      src={subtitle.url}
      srcLang={subtitle.languageSubTag}
      label={subtitle.displayLanguage}
      default={subtitle.isDefault}
      key={subtitle.languageSubTag}
    />
  ));

const PlayerMarkup = ({ playerData, className, toggles = {} }: IPlayerMarkupProps) => {
  const playerNode = useRef(null);

  const data = {
    ...playerData,
    flags: toggles,
  };

  usePlayer(playerNode, { ...data });

  const { updateWatchTime } = useWatchTime();

  const playerProps = {
    onTimeUpdate: updateWatchTime,
    ref: playerNode,
    className: classNames('video-js', className),
    'data-testid': 'video-markup',
    playsInline: true,
  };

  if (playerData.audio)
    return <audio {...playerProps}>{playerData.subtitles && renderTrackElements(playerData.subtitles)}</audio>;

  return <video {...playerProps}>{playerData.subtitles && renderTrackElements(playerData.subtitles)}</video>;
};

export default withUnleash(PlayerMarkup);
